import { render, staticRenderFns } from "./RisksLegend.vue?vue&type=template&id=7637eccf&scoped=true&"
import script from "./RisksLegend.vue?vue&type=script&lang=js&"
export * from "./RisksLegend.vue?vue&type=script&lang=js&"
import style0 from "./RisksLegend.vue?vue&type=style&index=0&id=7637eccf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7637eccf",
  null
  
)

export default component.exports